import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import {
  HorizontalScrollContainer,
  Typography,
  useBreakpoint
} from '@americanexpress/aqx-components';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { getG170CombinedData } from '../redux';
import styles from '../__styles__/desktopVariant.scss?modules';

const DesktopFilmStrip = ({ isG170Desktop, g170StaticData, currCard }) => {
  const currentRef = useRef(null);
  const { sm } = useBreakpoint();
  const currShortName = currCard?.shortName;
  const needToRender = !sm && isG170Desktop;
  const { content = [], dtmEvents = [] } = g170StaticData || {};
  const scrollDtmLeft = dtmEvents.find(dtm => dtm.key === 'desktopLeftScrollClick');
  const scrollDtmRight = dtmEvents.find(
    dtm => dtm.key === 'desktopRightScrollClick'
  );
  const cardClickDtm = dtmEvents.find(dtm => dtm.key === 'desktopClick');

  useEffect(
    () => {
      const clsName = 'g170Desktop';

      if (needToRender && currentRef.current) {
        currentRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      if (needToRender) {
        document.body.classList.add(clsName);
      }

      return () => {
        if (needToRender) {
          document.body.classList.remove(clsName);
        }
      };
    },
    [needToRender]
  );

  if (!needToRender) {
    return null;
  }

  return (
    <div className={styles.desktopFilmStrip}>
      <HorizontalScrollContainer
        rightButtonProps={{
          onClick: () => {
            sendDTMClickEvent(scrollDtmRight);
          }
        }}
        leftButtonProps={{
          onClick: () => {
            sendDTMClickEvent(scrollDtmLeft);
          }
        }}
      >
        <section className={styles.carouselSection}>
          {content.map((item, i) => (
            <a
              key={i}
              className={clsx(styles.cta, {
                [styles.currentCard]: currShortName === item?.shortName
              })}
              href={item?.url}
              onClick={() => {
                const dtm = {
                  ...(cardClickDtm || {}),
                  eventAsset: replaceStringWithVars({
                    varsObject: {
                      cardName: item.dtmName || item.shortName
                    },
                    string: cardClickDtm?.eventAsset
                  })
                };
                sendDTMClickEvent(dtm);
              }}
              ref={currShortName === item?.shortName ? currentRef : null}
            >
              <img src={item?.imageName} alt="" />
              <Typography Component="span" className={styles.ctaTxt}>
                {item?.name}
              </Typography>
            </a>
          ))}
        </section>
      </HorizontalScrollContainer>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getG170CombinedData(state)
  };
};

export default connect(mapStateToProps)(React.memo(DesktopFilmStrip));
